import { Box, Dialog, DialogContent, DialogTitle, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import React from "react";
import CompanyEmployeeGAPRadar from "./CompanyEmployeeGAPRadar";
import CompanyEmployeeCoursesRadar from "./CompanyEmployeeCoursesRadar";

const IndividualEmployeeModal = (props) => {

	const handleClose = () => {
		props.onClose()
	};
	
	const getDate = (dateString) => {
		let d = new Date(dateString);
		return d.toLocaleDateString();
	};
	
	return (
		<Dialog
			open={props.employee? true : false}
			onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			fullWidth={true}
			maxWidth="lg"
		>
			<DialogTitle id="alert-dialog-title">
				{(props.employee)? `${props.employee.firstname} ${props.employee.lastname}` : ""}
			</DialogTitle>
			<DialogContent>
				{(props.employee)?
					<Stack direction="column" spacing={2}>
						{ props.employee.gapCourses?
							<React.Fragment>
								<Stack direction="row" spacing={2} justifyContent="space-evenly" sx={{ width: "100%"}}>
									<CompanyEmployeeGAPRadar gapCourses={props.employee.gapCourses}/>
									<CompanyEmployeeCoursesRadar employeeCourses={props.employee.courses}/>
								</Stack>
							</React.Fragment>
						:
							<Stack direction="column" spacing="0.75em">
								<Typography sx={{ width: "100%", fontWeight: "bold", textAlign: "center" }}>
									Course Statistics
								</Typography>
								<Typography>
									<span style={{ fontWeight: "bold", marginRight: "1em" }}>{`GAP Analysis:`}</span>
									{`GAP Analysis results are unavailable`}
								</Typography>
								<Typography>
									<span style={{ fontWeight: "bold", marginRight: "1em" }}>{`Courses Enrolled:`}</span>
									{`${props.employee.courses.length}`}
								</Typography>
								<Typography>
									<span style={{ fontWeight: "bold", marginRight: "1em" }}>{`Courses Started:`}</span>
									{`${props.employee.courseStats.coursesStarted}`}
								</Typography>
								<Typography>
									<span style={{ fontWeight: "bold", marginRight: "1em" }}>{`Courses Completed:`}</span>
									{`${props.employee.courseStats.coursesCompleted}`}
								</Typography>
								<Typography>
									<span style={{ fontWeight: "bold", marginRight: "1em" }}>
										{`Avg. Completion Days From Start:`}
									</span>
									{`${props.employee.courseStats.averageCompletionDaysFromStart.toFixed(1)}`}
								</Typography>
								<Typography>
									<span style={{ fontWeight: "bold", marginRight: "1em" }}>
										{`Avg. Completion Days From Enrollment:`}
									</span>
									{`${props.employee.courseStats.averageCompletionDaysFromEnrol.toFixed(1)}`}
								</Typography>
								<Typography>
									<span style={{ fontWeight: "bold", marginRight: "1em" }}>{`Total Retries:`}</span>
									{`${props.employee.courseStats.totalRetries}`}
								</Typography>
								<Typography>
									<span style={{ fontWeight: "bold", marginRight: "1em" }}>{`Average Retries:`}</span>
									{`${props.employee.courseStats.averageRetries.toFixed(2)}`}
								</Typography>
								<Typography>
									<span style={{ fontWeight: "bold", marginRight: "1em" }}>{`Average Grade:`}</span>
									{`${props.employee.courseStats.averageGrade}`}
								</Typography>
							</Stack>
						}
						<TableContainer component={Paper}>
							<Table>
								<TableHead>
									<TableRow>
										<TableCell sx={{ textAlign: "left" }}>Course Name</TableCell>
										<TableCell sx={{ textAlign: "center" }}>Course Enrolled</TableCell>
										<TableCell sx={{ textAlign: "center" }}>Course Completed</TableCell>
										<TableCell sx={{ textAlign: "center" }}>Retries</TableCell>
										<TableCell sx={{ textAlign: "center" }}>Score</TableCell>
										<TableCell sx={{ textAlign: "center" }}>Grade</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{props.employee.courses.map((course, i) => {
										return (
											<TableRow>
												<TableCell sx={{ textAlign: "left" }}>{course.label}</TableCell>
												<TableCell sx={{ textAlign: "center" }}>
													{getDate(course.enrol_date)}
												</TableCell>
												<TableCell sx={{ textAlign: "center" }}>
													{course.complete_date?getDate(course.complete_date) : "-"}
												</TableCell>
												<TableCell sx={{ textAlign: "center" }}>{course.retries}</TableCell>
												<TableCell sx={{ textAlign: "center" }}>{course.score}</TableCell>
												<TableCell sx={{ textAlign: "center" }}>{course.grade}</TableCell>
											</TableRow>
										)
									})}
								</TableBody>
							</Table>
						</TableContainer>
						{props.employee.gapCourses?
							<Stack direction="row" spacing={2} justifyContent="space-evenly" sx={{ width: "100%", paddingTop: "5em" }}>
								<Stack direction="column" spacing={1} alignItems="left">
									<Typography sx={{ width: "100%", fontWeight: "bold", textAlign: "center" }}>
										Course Statistics
									</Typography>
									<Typography>
										<span style={{ fontWeight: "bold", marginRight: "1em" }}>{`Courses Enrolled:`}</span>
										{`${props.employee.courses.length}`}
									</Typography>
									<Typography>
										<span style={{ fontWeight: "bold", marginRight: "1em" }}>{`Courses Started:`}</span>
										{`${props.employee.courseStats.coursesStarted}`}
									</Typography>
									<Typography>
										<span style={{ fontWeight: "bold", marginRight: "1em" }}>{`Courses Completed:`}</span>
										{`${props.employee.courseStats.coursesCompleted}`}
									</Typography>
									<Typography>
										<span style={{ fontWeight: "bold", marginRight: "1em" }}>
											{`Avg. Completion Days From Start:`}
										</span>
										{`${props.employee.courseStats.averageCompletionDaysFromStart.toFixed(1)}`}
									</Typography>
									<Typography>
										<span style={{ fontWeight: "bold", marginRight: "1em" }}>
											{`Avg. Completion Days From Enrollment:`}
										</span>
										{`${props.employee.courseStats.averageCompletionDaysFromEnrol.toFixed(1)}`}
									</Typography>
									<Typography>
										<span style={{ fontWeight: "bold", marginRight: "1em" }}>{`Total Retries:`}</span>
										{`${props.employee.courseStats.totalRetries}`}
									</Typography>
									<Typography>
										<span style={{ fontWeight: "bold", marginRight: "1em" }}>{`Average Retries:`}</span>
										{`${props.employee.courseStats.averageRetries.toFixed(2)}`}
									</Typography>
									<Typography>
										<span style={{ fontWeight: "bold", marginRight: "1em" }}>{`Average Grade:`}</span>
										{`${props.employee.courseStats.averageGrade}`}
									</Typography>
								</Stack>
								<Stack direction="column" spacing={1} alignItems="left">
									<Typography sx={{ width: "100%", fontWeight: "bold", textAlign: "center" }}>
										GAP Analysis Results
									</Typography>
									{ props.employee.gapCourses.map((gapCourse, i) => {
										return (
											<Typography key={`${gapCourse.course_name}_${i}`}>
												<span style={{
													fontWeight: "bold",
													marginRight: "1em"
												}}>
													{`${gapCourse.course_name}:`}
												</span>
												{`${gapCourse.score} (${gapCourse.grade})`}
											</Typography>
										);
									})}
								</Stack>
							</Stack>
							: <React.Fragment/> }
					</Stack>
				: <React.Fragment/>
				}
			</DialogContent>
		</Dialog>
	);

}

export default IndividualEmployeeModal;